// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-1ff5a4a3] .new-conversation-modal .modal-title .icon{top:2px;position:relative}", ""]);
// Exports
module.exports = exports;
